module.exports = __webpack_public_path__ + "static/media/16UNODC23.fe128424.jpg";